/* assets/cart-discount.js
 * Applica/Rimuove codici sconto SUL CARRELLO (no query sul checkout)
 * e mostra un messaggio minimal: "Codice applicato" / "Codice non valido".
 */
/* assets/cart-discount.js
 * Applica/Rimuove codici sconto SUL CARRELLO (no query sul checkout).
 * - Usa /cart/update.js con Section Rendering per aggiornare totali e righe sconto
 * - Non modifica in alcun modo il link "Checkout"
 * - Funziona sia nella cart page che nel cart drawer (se include lo snippet)
 */

/* assets/cart-discount.js
 * Applica/Rimuove codici SUL CARRELLO solo su azione utente (click "Applica" o Enter).
 * - Input disaccoppiato dal form carrello (no name="discount")
 * - Section Rendering per aggiornare totali/righe sconto/bubble
 * - Messaggi minimal: "Codice applicato" / "Codice non valido"
 * - Rete di sicurezza: rimuove qualsiasi "discount" da FormData del form carrello
 */

/* assets/cart-discount.js
 * Applica/rimuove codici SOLO su azione utente e impedisce applicazioni automatiche.
 * - Neutralizza qualunque <input name="discount"> (tema/app)
 * - Rimuove sconti pre-applicati da URL (?discount=...) o da sessione, se l’utente non ha cliccato "Applica" in questa sessione
 * - Section Rendering per aggiornare totali, righe sconto e bubble
 * - Messaggi minimal: "Codice applicato" / "Codice non valido"
 */

(function () {
  'use strict';

  // =================== Config & Selectors ===================
  var SELECTORS = {
    wrapper: '[data-cart-discount]',
    input: '[data-discount-input]',       // <-- niente name="discount" qui!
    apply: '[data-apply-discount]',
    remove: '[data-remove-discount]',
    message: '[data-message]'
  };
  var USER_FLAG_KEY = 'cartDiscount.userApplied'; // per questa sessione

  function shopRoot() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    catch (e) { return '/'; }
  }
  function userAppliedFlag(val) {
    try {
      if (typeof val === 'boolean') {
        if (val) sessionStorage.setItem(USER_FLAG_KEY, '1');
        else sessionStorage.removeItem(USER_FLAG_KEY);
        return;
      }
      return sessionStorage.getItem(USER_FLAG_KEY) === '1';
    } catch (e) { return false; }
  }

  // ============== Neutralizzazione input "discount" ==============
  function neutralizeNativeDiscountInputs(rootNode) {
    var scope = rootNode || document;
    scope.querySelectorAll('input[name="discount"]').forEach(function (el) {
      // se qualcuno inserisce un input con name="discount" nel form, lo disattiviamo
      el.removeAttribute('name');
      if (!el.hasAttribute('data-discount-input')) {
        el.setAttribute('data-discount-input', '');
      }
    });
  }

  // intercetta submit via FormData e rimuove sempre "discount"
  window.addEventListener('formdata', function (e) {
    try { e.formData.delete('discount'); } catch (err) {}
  });

  // Se qualche app/tema inietta nuovamente l'input, lo neutralizziamo subito
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (!m.addedNodes) return;
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('input[name="discount"]')) {
          neutralizeNativeDiscountInputs(n.parentNode || n);
        } else if (n.querySelector) {
          neutralizeNativeDiscountInputs(n);
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // =================== Section Rendering helpers ===================
  function detectSections(contextEl) {
    var set = new Set();
    var nearest = contextEl && contextEl.closest('[id^="shopify-section-"]');
    if (nearest && nearest.id) set.add(nearest.id.replace('shopify-section-', ''));
    ['cart-icon-bubble', 'cart-drawer', 'header'].forEach(function (sid) {
      if (document.getElementById('shopify-section-' + sid)) set.add(sid);
    });
    return Array.from(set).slice(0, 5); // limite Shopify
  }
  function replaceSections(sectionsMap) {
    if (!sectionsMap) return;
    Object.keys(sectionsMap).forEach(function (sectionId) {
      var html = sectionsMap[sectionId];
      var container = document.getElementById('shopify-section-' + sectionId);
      if (container && typeof html === 'string') container.innerHTML = html;
    });
  }

  // =================== Cart helpers ===================
  async function fetchCart() {
    var res = await fetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart.js failed');
    return await res.json();
  }
  function cartHasAnyDiscount(cart) {
    if (!cart) return false;
    var apps = cart.cart_level_discount_applications || cart.discount_applications || [];
    if (Array.isArray(apps) && apps.length) return true;
    var items = cart.items || cart.line_items || [];
    return items.some(function (li) {
      var da = li.discount_allocations || [];
      return da.length > 0;
    });
  }

  async function updateCartWithDiscount(code, fromEl) {
    var root = shopRoot();
    var sections = detectSections(fromEl || document);
    var res = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        discount: code,                              // '' per rimuovere
        sections: sections.join(','),
        sections_url: window.location.pathname || '/'
      })
    });

    if (!res.ok) {
      // Fallback: applica/rimuovi via redirect (non tocca il link al checkout)
      if (code) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
      else window.location.href = root + 'cart';
      return null;
    }

    var data = await res.json();
    if (data && data.sections) replaceSections(data.sections);
    else { window.location.reload(); return null; }
    return data;
  }

  // =================== UI helpers ===================
  function messageEl() {
    var wrap = document.querySelector(SELECTORS.wrapper);
    return wrap ? wrap.querySelector(SELECTORS.message) : null;
  }
  function showMessage(text, state) {
    var el = messageEl();
    if (!el) return;
    el.textContent = text || '';
    if (state) el.setAttribute('data-state', state); else el.removeAttribute('data-state');
  }
  function ctxFrom(target) {
    var wrap = target.closest(SELECTORS.wrapper) || document.querySelector(SELECTORS.wrapper);
    return { wrap: wrap, input: wrap ? wrap.querySelector(SELECTORS.input) : null };
  }

  // =================== Event handlers ===================
  async function applyHandler(btn) {
    var ctx = ctxFrom(btn);
    if (!ctx.input) return;

    var raw = (ctx.input.value || '').trim();
    if (!raw) { showMessage('Inserisci un codice'); return; }

    userAppliedFlag(true); // marcatura: azione utente

    try {
      var before = await fetchCart();
      var hadBefore = cartHasAnyDiscount(before);

      var data = await updateCartWithDiscount(raw.replace(/\s*,\s*/g, ','), ctx.wrap);
      if (!data) return;

      var after = await fetchCart();
      var hasAfter = cartHasAnyDiscount(after);

      if (!hadBefore && hasAfter) showMessage('Codice applicato', 'success');
      else if (hadBefore && hasAfter) showMessage('Codice applicato', 'success');
      else { showMessage('Codice non valido', 'error'); userAppliedFlag(false); }
    } catch (err) {
      console.error(err);
      showMessage('Codice non valido', 'error');
      userAppliedFlag(false);
    }
  }

  async function removeHandler(btn) {
    var ctx = ctxFrom(btn);
    try {
      await updateCartWithDiscount('', ctx.wrap);
      userAppliedFlag(false);
      showMessage(''); // minimal: nessun testo alla rimozione
    } catch (err) {
      console.error(err);
      showMessage('Impossibile rimuovere il codice', 'error');
    }
  }

  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest(SELECTORS.apply);
    if (applyBtn) { e.preventDefault(); applyHandler(applyBtn); return; }
    var removeBtn = e.target.closest(SELECTORS.remove);
    if (removeBtn) { e.preventDefault(); removeHandler(removeBtn); }
  });

  document.addEventListener('keydown', function (e) {
    if (!e.target || !e.target.matches(SELECTORS.input)) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      var applyBtn = e.target.closest(SELECTORS.wrapper)?.querySelector(SELECTORS.apply);
      if (applyBtn) applyHandler(applyBtn);
    }
  });

  // =================== Guardia all’avvio ===================
  async function stripURLDiscountParamAndCart(ctx) {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.has('discount')) {
        // rimuove lo sconto arrivato via URL e pulisce la barra indirizzi
        await updateCartWithDiscount('', ctx || document);
        url.searchParams.delete('discount');
        history.replaceState({}, '', url.pathname + url.hash);
      }
    } catch (e) {}
  }

  async function boot() {
    neutralizeNativeDiscountInputs();

    var wrap = document.querySelector(SELECTORS.wrapper);
    if (!wrap) return;

    // 1) se arrivo con ?discount= nel link, rimuovo e pulisco URL
    await stripURLDiscountParamAndCart(wrap);

    // 2) se NON ho cliccato "Applica" in questa sessione ma trovo uno sconto attivo,
    //    lo rimuovo (cookie/sessione/redirect passati)
    try {
      if (!userAppliedFlag()) {
        var cart = await fetchCart();
        if (cartHasAnyDiscount(cart)) {
          await updateCartWithDiscount('', wrap);
        }
      }
    } catch (e) {
      console.warn('Guardia sconto: skip', e);
    }
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
